/*
* All menu items are defined in the NavSchema object in the global scope added by the file sections/header.liquid
**/

import {Component} from "react";
import {NavSchema, MenuHeader, SubMenu, SubImage, SubMenuFirstLevel, SubMenuSecondLevel} from "../types";

export default class Menu extends Component<any, any> {
  private readonly NavSchema: NavSchema = window.NavSchema;
  private readonly internalNavSchema: Array<{}> = [];

  constructor(props: any) {
    super(props);
    let currentArray: any = [];

    this.NavSchema.forEach((item: any) => {
        if (item.type === 'menu-header') {
          if (currentArray.length > 0) {
            this.internalNavSchema.push(currentArray);
          }
          currentArray = [];
          currentArray.push(item);
          return;
        }
        currentArray.push(item);
      }
    );

    if (currentArray.length > 0) {
      this.internalNavSchema.push(currentArray);
    }
  }

  render() {
    return (
      <div>
        <ul className='tw-flex tw-gap-8'>
          {this.internalNavSchema.map((menuChildren: any) =>
            <li>
              <a className={'navigation-link'} href={menuChildren[0].labelLink}>{menuChildren[0].label}</a>
              {menuChildren.length > 1 && <span className={'mouse-catcher'}></span>}
              {menuChildren.length > 1 &&
                <div className={'menu-container'}>
                  <div className={'menu-inner'}>
                    {menuChildren.slice(1).map((item: MenuHeader | SubMenu | SubImage) =>
                      <div>
                        {item.type == 'sub-menu' &&
                          item.firstLevelSubMenus.map((subMenuFirstLevel: SubMenuFirstLevel) =>
                            <ul className={'sub-menu'}>
                              <li>
                                <a className={'sub-menu-title'} href={subMenuFirstLevel.firstLevelSubMenuLink}>{subMenuFirstLevel.firstLevelSubMenuTitle}</a>
                                {subMenuFirstLevel.secondLevelSubMenus.length > 0 &&
                                  <ul className={'sub-menu-links'}>
                                    {subMenuFirstLevel.secondLevelSubMenus.map((secondLevelSubMenu: SubMenuSecondLevel) =>
                                      <li>
                                        <a
                                          href={secondLevelSubMenu.secondLevelSubMenuLink}>{secondLevelSubMenu.secondLevelSubMenuTitle}</a>
                                      </li>
                                    )}
                                  </ul>
                                }
                              </li>
                            </ul>
                          )
                        }
                        {item.type == 'sub-image' &&
                          <div className={'sub-image'}>
                            <a href={item.imageLink} className={`tw-block tw-mb-4 ${!item.imageLink && 'tw-pointer-events-none'}`}>
                              <img src={item.image} alt=""/>
                            </a>
                            {item.subLabel && item.subLabelLink &&
                              <a href={item.subLabelLink} className={'sub-label'}>{item.subLabel}</a>
                            }
                          </div>
                        }
                      </div>
                    )}
                  </div>
                </div>
              }
            </li>
          )}
        </ul>
      </div>
    )
  }
}
